import { styled } from "@mui/material";

export const StyledDate = styled("div", {
  shouldForwardProp: (prop) => !['color'].includes(prop.toString()),
})<{
  color?: string;
}>(({ theme, color }) => ({
  display: 'block',
  color: color || theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
  fontFamily: theme.typography.fontFamily,
  padding: '0',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  '&.empty': {
    color: theme.palette.text.disabled,
    fontStyle: 'italic',
    cursor: 'default',
  }
}));
